/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { TextArea } from '@carbon/react';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { useFormHelpers } from '../../hooks/useFormHelpers';

const TextAreaWithCharacterCount = props => {
  const { field, labelText, placeholder, readOnly } = props;
  const formMethods = useFormContext();
  const { getFieldValue, registerInputField } = useFormHelpers(formMethods);

  const characterCounter = () => {
    const { field, maximumFieldLength } = props;
    const value = getFieldValue(field);
    var fieldLength = 0;
    var length = 0;
    if (value) {
      fieldLength = value.length;
      length = fieldLength > 0 ? fieldLength : 0;
    }
    return `${length}/${maximumFieldLength}`;
  };

  return (
    <div className="TabContent__textarea-label">
      <TextArea
        {...registerInputField({ field })}
        readOnly={readOnly}
        cols={50}
        rows={3}
        labelText={
          <div className="TabContent__textarea-counter">
            <div>
              <FormattedMessage {...labelText} />
            </div>
            <div>{characterCounter()}</div>
          </div>
        }
        placeholder={placeholder}
      />
    </div>
  );
};

TextAreaWithCharacterCount.propTypes = {
  readOnly: PropTypes.bool,
  field: PropTypes.string.isRequired,
  labelText: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  maximumFieldLength: PropTypes.any
};
TextAreaWithCharacterCount.defaultProps = {
  readOnly: false
};

export { TextAreaWithCharacterCount };
